module.exports = __webpack_public_path__ + "static/media/nunito_bold.ed1caa25.ttf";